import axios from "./axios";

const createObituary = async (formData: FormData) => {
  const endpoint = "/obituary";
  const response = await axios.post(endpoint, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

const getObituaryById = async (slugKey: any) => {
  const response = await axios.get(`/obituary?slugKey=${slugKey}`);
  return response.data || null;
};

const getObituary = async (queryParams?: {
  city?: string;
  region?: string;
  id?: string;
  userId?: string;
  page?: number;
  date?: string;
  limit?: number;
  days?: number;
  startDate?: string;
  endDate?: string;
  allow?: string;
}) => {
  try {
    const endpoint = "/obituary";
    const response = await axios.get(endpoint, { params: queryParams });
    return response.data;
  } catch (error: any) {
    console.error("Error fetching obituaries:", error);
    return {
      error:
        error?.response?.data?.message ||
        error?.message ||
        "Internal Server Error",
    };
  }
};

const getCompanyPageObituary = async (queryParams?: {
  city?: string;
  userId?: string;
}) => {
  try {
    const endpoint = "/obituary/company-page";
    const response = await axios.get(endpoint, { params: queryParams });
    return response.data;
  } catch (error: unknown) {
    console.error("Error fetching obituaries:", error);
    // throw new Error("Network error or no response");
  }
};

//memory
// accessToken: what the server gave when the code of a private page was entered; kept only in the open page.
const getMemory = async (queryParams?: { slugKey?: string }, accessToken?: string | null) => {
  try {
    const endpoint = "/obituary/memory";
    const response = await axios.get(endpoint, {
      params: queryParams,
      ...(accessToken ? { headers: { "X-Obituary-Access": accessToken } } : {}),
    });
    return response.data;
  } catch (error: unknown) {
    // A deleted / blocked / unknown page: the server answers 404 and the page must be a real 404.
    if ((error as any)?.response?.status === 404) return { notFound: true };
    console.error("Error fetching obituaries:", error);
    // throw new Error("Network error or no response");
  }
};

// Home page "V zadnjih dneh" tab: top 8 current obituaries by candles, in random order.
const getTrendingObituaries = async (queryParams?: {
  city?: string;
  region?: string;
  name?: string;
}) => {
  try {
    const response = await axios.get("/obituary/trending", {
      params: queryParams,
    });
    return response.data;
  } catch (error: any) {
    console.error("Error fetching trending obituaries:", error);
    return {
      error:
        error?.response?.data?.message ||
        error?.message ||
        "Internal Server Error",
    };
  }
};

const getFunerals = async (queryParams?: {
  city?: string;
  region?: string;
  id?: string;
  startDate?: string;
  endDate?: string;
}) => {
  try {
    const endpoint = "/obituary/funerals";

    const response = await axios.get(endpoint, { params: queryParams });
    return response.data;
  } catch (error: unknown) {
    console.error("Error fetching obituaries:", error);
    // throw new Error("Network error or no response");
  }
};

const getCompanyPageFunerals = async (queryParams?: {
  city?: string;
  region?: string;
  id?: string;
  startDate?: string;
  endDate?: string;
}) => {
  try {
    const endpoint = "/obituary/company-page/funerals";

    const response = await axios.get(endpoint, { params: queryParams });
    return response.data;
  } catch (error: unknown) {
    console.error("Error fetching obituaries:", error);
    // throw new Error("Network error or no response");
  }
};

const updateObituary = async (
  id: string,
  formData: FormData,
  allow: string = "",
) => {
  try {
    const endpoint = `/obituary/${id}?allow=${allow}`;
    const response = await axios.patch(endpoint, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating obituary:", error);
    throw error;
  }
};

const updateObituaryVisits = async (data: any) => {
  try {
    const endpoint = `/obituary/visits/${data.obituaryId}?isNoFloristLimit=true`;
    const response = await axios.patch(endpoint, data);
    return response.data;
  } catch (error: any) {
    console.error("Error updating obituary visits:", error);
    return {
      error:
        error?.response?.data?.message ||
        error?.message ||
        "Internal Server Error",
    };
  }
};
//add sorrow book
const createSorrowBook = async (id: string, data: any) => {
  try {
    const endpoint = `/sorrow-book/${id}`;
    const response = await axios.post(endpoint, data);
    return response.data;
  } catch (error: any) {
    if (error.response) {
      console.error("API Error:", error.response.data);
      throw error.response;
    } else {
      console.error("Network error:", error);
      // throw new Error("Network error or no response");
    }
  }
};

// add dedication
const createDedication = async (id: string, data: any) => {
  try {
    const endpoint = `/dedication/${id}`;
    const response = await axios.post(endpoint, data);
    return response.data;
  } catch (error: any) {
    if (error.response) {
      console.error("API Error:", error.response.data);
      throw error.response;
    } else {
      console.error("Network error:", error);
      // throw new Error("Network error or no response");
    }
  }
};

//add photo
const addPhoto = async (id: string, formData: FormData) => {
  try {
    const endpoint = `/photo/${id}`;
    const response = await axios.post(endpoint, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error: any) {
    console.error("Error adding photo:", error);
    return {
      // The server explains a refusal in `error` (e.g. the daily limit of photos); older answers used `message`.
      error:
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        "Internal Server Error",
    };
  }
};

// add condolence
const createCondolence = async (id: string, data: any) => {
  try {
    const endpoint = `/condolence/${id}`;
    const response = await axios.post(endpoint, data);
    return response.data;
  } catch (error: any) {
    if (error.response) {
      console.error("API Error:", error.response.data);
      throw error.response;
    } else {
      console.error("Network error:", error);
      // throw new Error("Network error or no response");
    }
  }
};

// burn candle
const burnCandle = async (id: string, data: any) => {
  try {
    const endpoint = `/candle/${id}`;
    const response = await axios.post(endpoint, data);
    return response.data;
  } catch (error: any) {
    if (error.response) {
      console.error("API Error:", error.response.data);
      throw error.response;
    } else {
      console.error("Network error:", error);
      // throw new Error("Network error or no response");
    }
  }
};
//fetch pending posts
const fetchPendingPosts = async () => {
  try {
    const endpoint = `/obituary/pending-data`;
    const response = await axios.get(endpoint);

    return response.data;
  } catch (error: any) {
    if (error.response) {
      console.error("API Error:", error.response.data);
      throw error.response;
    } else {
      console.error("Network error:", error);
      // throw new Error("Network error or no response");
    }
  }
};
//change post status
const changePostStatus = async (data: any) => {
  try {
    const endpoint = `/post`;
    const response = await axios.post(endpoint, data);

    return response.data;
  } catch (error: any) {
    if (error.response) {
      console.error("API Error:", error.response.data);
      throw error.response;
    } else {
      console.error("Network error:", error);
      // throw new Error("Network error or no response");
    }
  }
};

//add report
const addReport = async (id: string, data: any) => {
  try {
    const endpoint = `/report/${id}`;
    const response = await axios.post(endpoint, data);
    return response.data;
  } catch (error: any) {
    console.error("Error submitting report:", error);
    return {
      error:
        error?.response?.data?.message ||
        error?.message ||
        "Internal Server Error",
    };
  }
};

//get memories
const getMemories = async () => {
  try {
    const endpoint = `/obituary/memories`;
    const response = await axios.get(endpoint);
    return response.data;
  } catch (error: any) {
    console.error("Error Getting Memories:", error);
    return {
      error:
        error?.response?.data?.message ||
        error?.message ||
        "Internal Server Error",
    };
  }
};

const getKeeperMemories = async () => {
  try {
    const endpoint = `/obituary/keeper/memories`;
    const response = await axios.get(endpoint);
    return response.data;
  } catch (error: any) {
    console.error("Error Getting Keeper Memories:", error);
    return {
      error:
        error?.response?.data?.message ||
        error?.message ||
        "Internal Server Error",
    };
  }
};

// The Keeper's history of a memory page (contributions, payments, system notes) and removing / restoring an entry.
const getKeeperEntries = async (obituaryId: number) => {
  const response = await axios.get(`/logs/keeper/${obituaryId}`);
  return response.data as { entries: any[]; retentionDays: number };
};
const removeKeeperEntry = async (kind: string, id: number) => {
  const response = await axios.post("/logs/keeper/remove", { kind, id });
  return response.data;
};
const restoreKeeperEntry = async (kind: string, id: number) => {
  const response = await axios.post("/logs/keeper/restore", { kind, id });
  return response.data;
};

const getMemoryLogs = async (id: number) => {
  try {
    const endpoint = `/logs/${id}`;
    const response = await axios.get(endpoint);
    return response.data;
  } catch (error: any) {
    console.error("Error Getting Memory Logs:", error);
    return {
      error:
        error?.response?.data?.message ||
        error?.message ||
        "Internal Server Error",
    };
  }
};

// Removes one of the user's own contributions ("Moje žalne vsebine").
const getLogs = async () => {
  try {
    const endpoint = `/obituary/logs/`;
    const response = await axios.get(endpoint);
    return response.data;
  } catch (error: any) {
    console.error("Error Getting Logs:", error);
    return {
      error:
        error?.response?.data?.message ||
        error?.message ||
        "Internal Server Error",
    };
  }
};

const getGiftLogs = async () => {
  try {
    const endpoint = `/logs/gifts/logs`;
    const response = await axios.get(endpoint);
    return response.data;
  } catch (error: any) {
    console.error("Error Getting Gift Logs:", error);
    return {
      error:
        error?.response?.data?.message ||
        error?.message ||
        "Internal Server Error",
    };
  }
};

const getApprovedData = async () => {
  try {
    const endpoint = `/post/approved`;
    const response = await axios.get(endpoint);
    return response.data;
  } catch (error: any) {
    console.error("Error Getting Approved Posts:", error);
    return {
      error:
        error?.response?.data?.message ||
        error?.message ||
        "Internal Server Error",
    };
  }
};

const getAdminMemories = async () => {
  try {
    const endpoint = `/obituary/admin/memories`;
    const response = await axios.get(endpoint);
    return response.data;
  } catch (error: any) {
    console.error("Error Getting Admin Memories:", error);
    return {
      error:
        error?.response?.data?.message ||
        error?.message ||
        "Internal Server Error",
    };
  }
};

const getCompanyObituaries = async (queryParams?: {
  page?: number;
  limit?: number;
}) => {
  try {
    const endpoint = `/obituary/company`;
    const response = await axios.get(endpoint, { params: queryParams });
    return response.data;
  } catch (error: any) {
    console.error("Error Getting Company Obituaries:", error);
    return {
      error:
        error?.response?.data?.message ||
        error?.message ||
        "Internal Server Error",
    };
  }
};

const getMonthlyCompanyData = async () => {
  try {
    const endpoint = `/obituary/company/monthly`;
    const response = await axios.get(endpoint);
    return response.data;
  } catch (error: any) {
    console.error("Error Getting Monthly Company Data:", error);
    return {
      error:
        error?.response?.data?.message ||
        error?.message ||
        "Internal Server Error",
    };
  }
};

const getCompanyLogs = async () => {
  try {
    const endpoint = `/obituary/company/logs/`;
    const response = await axios.get(endpoint);
    return response.data;
  } catch (error: any) {
    console.error("Error Getting Company Logs:", error);
    return {
      error:
        error?.response?.data?.message ||
        error?.message ||
        "Internal Server Error",
    };
  }
};
const getMemoryId = async (queryParams?: {
  city?: string;
  date?: string;
  type?: string;
}) => {
  try {
    const endpoint = `/obituary/id/`;
    const response = await axios.get(endpoint, { params: queryParams });
    return response.data;
  } catch (error: any) {
    console.error("Error Getting Memory ID:", error);
    return {
      error:
        error?.response?.data?.message ||
        error?.message ||
        "Internal Server Error",
    };
  }
};

const uploadObituaryTemplateCards = async (id: string, data: FormData) => {
  try {
    const endpoint = `/obituary/${id}/template-cards`;
    const response = await axios.patch(endpoint, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error: any) {
    console.error("Error Uploading Obituary Template Cards:", error);
    return {
      error:
        error?.response?.data?.message ||
        error?.message ||
        "Internal Server Error",
    };
  }
};

const getSingleObituaryById = async (id: any) => {
  const response = await axios.get(`/obituary?id=${id}`);
  return response.data || null;
};

const generateQR = async ({ id, slugKey }: { id: string; slugKey: string }) => {
  try {
    const endpoint = `/obituary/generate-qr`;
    const response = await axios.post(endpoint, { id, slugKey });
    return response.data;
  } catch (error: any) {
    console.error("Error generate-qr:", error);
    return {
      error:
        error?.response?.data?.message ||
        error?.message ||
        "Internal Server Error",
    };
  }
};

const getObituariesPaginated = async (queryParams?: {
  page?: number;
  limit?: number;
  name?: string;
  city?: string;
  region?: string;
  startDate?: string;
  endDate?: string;
}) => {
  try {
    const endpoint = "/obituary/paginated";
    const response = await axios.get(endpoint, { params: queryParams });
    return response.data;
  } catch (error: unknown) {
    console.error("Error fetching paginated obituaries:", error);
    throw error;
  }
};

const uploadMemoryImage = async (file: File, slugKey: any) => {
  try {
    const endpoint = `/logs/memory/image`; // backend endpoint for uploading image
    const formData = new FormData();
    formData.append("memory", file);
    formData.append("slugKey", slugKey);

    const response = await axios.post(endpoint, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    // response should return something like: { url: "https://..." }
    return response.data.url;
  } catch (error) {
    console.error("Error uploading image:", error);
    throw new Error("Failed to upload image");
  }
};

const updateObituaryPrivacy = async (
  id: number | string,
  data: { isPrivate: boolean; password?: string }
) => {
  const response = await axios.patch(`/obituary/${id}/privacy`, data);
  return response.data;
};

const verifyObituaryPassword = async (
  id: number | string,
  password: string
) => {
  const response = await axios.post(`/obituary/${id}/verify-password`, { password });
  return response.data;
};

const obituaryService = {
  getObituaryById,
  generateQR,
  createObituary,
  getGiftLogs,
  getObituary,
  getCompanyPageObituary,
  getMemory,
  getFunerals,
  getTrendingObituaries,
  getCompanyPageFunerals,
  updateObituary,
  updateObituaryVisits,
  createSorrowBook,
  createDedication,
  addPhoto,
  createCondolence,
  burnCandle,
  fetchPendingPosts,
  changePostStatus,
  getMemoryId,
  addReport,
  getLogs,
  getMemories,
  getKeeperMemories,
  getMemoryLogs,
  getKeeperEntries,
  removeKeeperEntry,
  restoreKeeperEntry,
  getApprovedData,
  getAdminMemories,
  getCompanyObituaries,
  getMonthlyCompanyData,
  getCompanyLogs,
  uploadObituaryTemplateCards,
  getSingleObituaryById,
  uploadMemoryImage,
  getObituariesPaginated,
  updateObituaryPrivacy,
  verifyObituaryPassword,
};

export default obituaryService;
